import React, { useState, useEffect, useRef } from "react";

import {
  Container,
  Typography,
  TextField,
  Button,
  MenuItem,
  Grid,
  Paper,
  CircularProgress,
  Alert,
  Stack,
  Box,
  Avatar,
  Divider,
} from "@mui/material";

import {
  AssignmentOutlined,
  CloudUploadOutlined,
  SchoolOutlined,
  SubjectOutlined,
  CalendarMonthOutlined,
  SendOutlined,
} from "@mui/icons-material";

import Swal from "sweetalert2";
import api from "../../api/api";

import defaultAvatar from "./maleee.jpg";



const PostAssignment = () => {



  const theme = {

    primary:"#800020",

    secondary:"#a52a2a",

    background:"#f8f6f4",

    white:"#ffffff",

    border:"#ead9d9",

    text:"#333",

  };




  const styles = {


    page:{

      minHeight:"100vh",

      background:theme.background,

      padding:"30px 15px",

    },



    header:{

      background:
      `linear-gradient(135deg,${theme.primary},${theme.secondary})`,

      color:"#fff",

      padding:"25px",

      borderRadius:"20px",

      marginBottom:"25px",

      boxShadow:
      "0 10px 30px rgba(128,0,32,.25)",

    },



    card:{

      background:theme.white,

      borderRadius:"22px",

      padding:"30px",

      border:
      `1px solid ${theme.border}`,

      boxShadow:
      "0 8px 25px rgba(0,0,0,.08)",

    },



    input:{

      "& .MuiOutlinedInput-root":{

        borderRadius:"12px",

      },


    },



    button:{

      background:
      `linear-gradient(135deg,${theme.primary},${theme.secondary})`,

      color:"#fff",

      borderRadius:"12px",

      padding:"12px 30px",

      fontWeight:"bold",

      "&:hover":{

        background:theme.primary

      }

    }



  };






  const [subjects,setSubjects]=useState([]);

  const [gradeClasses,setGradeClasses]=useState([]);



  const [form,setForm]=useState({

    title:"",

    description:"",

    due_date:"",

    subject:"",

    grade_class:"",

    file:null,

  });



  const [loading,setLoading]=useState(false);

  const [fetching,setFetching]=useState(true);

  const [error,setError]=useState("");



  const fileInputRef=useRef(null);







  useEffect(()=>{


    const fetchTeacherData=async()=>{


      try{


        const res=
        await api.get(
          "/api/users/teacher-subjects/"
        );



        setSubjects(
          res.data.subjects || []
        );



        setGradeClasses(
          res.data.grade_classes || []
        );



      }

      catch(err){


        console.error(err);


        setError(
          "Failed loading teacher information."
        );


      }

      finally{


        setFetching(false);


      }


    };



    fetchTeacherData();



  },[]);







  const handleChange=(e)=>{


    const {
      name,
      value
    }=e.target;



    setForm(prev=>({

      ...prev,

      [name]:value

    }));


  };








  const handleFileChange=(e)=>{


    setForm(prev=>({

      ...prev,

      file:e.target.files[0]

    }));


  };







  const resetForm=()=>{


    setForm({

      title:"",

      description:"",

      due_date:"",

      subject:"",

      grade_class:"",

      file:null,

    });



    if(fileInputRef.current)

      fileInputRef.current.value="";


  };








  const handleSubmit=async(event)=>{


    event.preventDefault();



    const {
      title,
      description,
      subject,
      grade_class,
      due_date,
      file

    }=form;



    if(
      !title ||
      !subject ||
      !grade_class ||
      !due_date
    ){


      Swal.fire(

        "Missing Information",

        "Please complete required fields.",

        "error"

      );


      return;


    }





    try{


      setLoading(true);



      const formData=
      new FormData();



      formData.append(
        "title",
        title
      );


      formData.append(
        "description",
        description || ""
      );


      formData.append(
        "subject",
        subject
      );


      formData.append(
        "grade_class",
        grade_class
      );


      formData.append(
        "due_date",
        due_date
      );



      if(file)

        formData.append(
          "attachment",
          file
        );





      await api.post(

        "/api/assignments/",

        formData,

        {

          headers:{

            "Content-Type":
            "multipart/form-data"

          }

        }

      );





      Swal.fire(

        "Success",

        "Assignment posted successfully!",

        "success"

      );



      resetForm();



    }

    catch(err){



      Swal.fire(

        "Error",

        err.response?.data
        ?
        JSON.stringify(err.response.data)
        :
        err.message,

        "error"

      );


    }

    finally{


      setLoading(false);


    }


  };










  return (


  <Box sx={styles.page}>


    <Container maxWidth="md">



      <Box sx={styles.header}>


        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
        >


          <Avatar

            src={defaultAvatar}

            sx={{

              width:60,

              height:60,

              border:
              "3px solid white"

            }}

          />



          <Box>


            <Typography
              variant="h5"
              fontWeight="bold"
            >

              Create Assignment

            </Typography>


            <Typography>

              Share learning tasks with your students

            </Typography>


          </Box>



        </Stack>


      </Box>







      <Paper sx={styles.card}>


        <Stack spacing={3}>


          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
          >

            <AssignmentOutlined
              sx={{
                color:theme.primary
              }}
            />


            <Typography
              variant="h6"
              fontWeight="bold"
            >

              New Assignment Post

            </Typography>


          </Stack>



          <Divider/>




          {
            fetching &&

            <Alert severity="info">

              Loading teacher subjects...

            </Alert>

          }



          {
            error &&

            <Alert severity="error">

              {error}

            </Alert>

          }






          <form onSubmit={handleSubmit}>


            <Stack spacing={3}>


              <TextField

                label="Assignment Title"

                name="title"

                value={form.title}

                onChange={handleChange}

                fullWidth

                required

                sx={styles.input}

              />




              <TextField

                label="Description"

                name="description"

                value={form.description}

                onChange={handleChange}

                multiline

                rows={5}

                fullWidth

                sx={styles.input}

              />





              <Grid container spacing={2}>


                <Grid item xs={12} sm={6}>


                  <TextField

                    select

                    label="Subject"

                    name="subject"

                    value={form.subject}

                    onChange={handleChange}

                    fullWidth

                    required

                    sx={styles.input}

                  >


                  {
                    subjects.map(
                      subject=>(

                      <MenuItem
                        key={subject.id}
                        value={subject.id}
                      >

                        {subject.name}

                      </MenuItem>

                      )
                    )
                  }


                  </TextField>


                </Grid>






                <Grid item xs={12} sm={6}>


                  <TextField

                    select

                    label="Grade Class"

                    name="grade_class"

                    value={form.grade_class}

                    onChange={handleChange}

                    fullWidth

                    required

                    sx={styles.input}

                  >



                  {
                    gradeClasses.map(
                      item=>(

                      <MenuItem
                        key={item.id}
                        value={item.id}
                      >

                        {item.name}

                      </MenuItem>

                      )
                    )
                  }



                  </TextField>


                </Grid>



              </Grid>






              <TextField

                type="date"

                label="Due Date"

                name="due_date"

                value={form.due_date}

                onChange={handleChange}

                fullWidth

                required

                InputLabelProps={{
                  shrink:true
                }}

                sx={styles.input}

              />






              <Button

                component="label"

                variant="outlined"

                startIcon={
                  <CloudUploadOutlined/>
                }

                sx={{

                  borderRadius:"12px",

                  color:theme.primary,

                  borderColor:theme.primary

                }}

              >

                Upload Attachment


                <input

                  hidden

                  type="file"

                  ref={fileInputRef}

                  onChange={handleFileChange}

                />


              </Button>





              <Button

                type="submit"

                disabled={
                  loading ||
                  fetching
                }

                startIcon={
                  loading
                  ?
                  <CircularProgress size={20}/>
                  :
                  <SendOutlined/>
                }

                sx={styles.button}

              >

                {
                  loading
                  ?
                  "Posting..."
                  :
                  "Post Assignment"
                }


              </Button>



            </Stack>


          </form>


        </Stack>


      </Paper>



    </Container>


  </Box>


  );

};


export default PostAssignment;